import axios from 'axios';
import mainVersionOneService from 'services/mainVersionOneService';

const CancelToken = axios.CancelToken;

let cancel;

export function tagList(portId: number) {
    return mainVersionOneService
        .get(`tags/${portId}/list`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function tagCreate(portId, data) {
    return mainVersionOneService
        .post(`tags/${portId}/create`, data)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function tagRecords(portId, data) {
    if (cancel !== undefined) {
        cancel();
    }
    const formatFilter = (d) => {
        return Object.keys(d)
            .filter((v) => {
                return d[v] != null;
            })
            .map((v) => {
                return `${v}:${d[v]}`;
            })
            .join(',');
    };
    const formatSearch = (d) => {
        return Object.keys(d)
            .filter((v) => {
                return d[v] != null;
            })
            .map((v) => {
                return `${d[v]}`;
            })
            .join(',');
    };

    let parameters = '';

    for (const key in data) {
        const value = data[key];
        switch (key) {
            case 'order':
                parameters = `${parameters}&order=${value.type}.${value.order}`;
                break;
            case 'page':
                parameters = `${parameters}&page=${value}`;
                break;
            case 'limit':
                parameters = `${parameters}&limit=${value}`;
                break;
            case 'filter':
                if (Object.keys(value).length >= 1) {
                    parameters = `${parameters}&filter=${formatFilter(value)}`;
                }
                break;
            case 'search':
                if (Object.keys(value).length >= 1) {
                    parameters = `${parameters}&search=${formatSearch(value)}`;
                }
                break;
        }
    }

    return mainVersionOneService
        .get(`tags/${portId}/records?rand=${new Date().getTime()}${parameters}`, {
            cancelToken: new CancelToken(function executor(c) {
                cancel = c;
            }),
        })
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function tagTransits(portId, id) {
    return mainVersionOneService
        .get(`tags/${portId}/${id}/transits`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function tagDelete(portId, id) {
    return mainVersionOneService
        .delete(`tags/${portId}/${id}/delete`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function tagRecord(portId, id) {
    return mainVersionOneService
        .get(`tags/${portId}/${id}`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function tagUpdate(portId, id, data) {
    return mainVersionOneService
        .put(`tags/${portId}/${id}/update`, data)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function tagOrder(portId, data) {
    return mainVersionOneService
        .patch(`tags/${portId}/order`, data)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function tagReassign(portId, data) {
    return mainVersionOneService
        .post(`tags/${portId}/reassign`, data)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}
